async function CoverPage(mainContent, getBase64ImageFromURL, documentMethods, stylesheet) {
    let contentObject = JSON.parse(mainContent || "{}")
    const [dungeonEpicsLogo] = contentObject?.images || []
    stylesheet?.value?.backgroundImage.commonBg && documentMethods.image(stylesheet?.value?.backgroundImage.commonBg, 0, 0, { width: documentMethods.page.width, height: documentMethods.page.height })
    if (dungeonEpicsLogo?.url) documentMethods.image(await getBase64ImageFromURL(dungeonEpicsLogo?.url), 0, 0, { width: documentMethods.page.width, height: documentMethods.page.height })
    else documentMethods.text(contentObject?.title, 270, 300)
}
export default CoverPage